import script from "./LoadingPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingPlaceholder.vue?vue&type=script&setup=true&lang=js"

import "./LoadingPlaceholder.vue?vue&type=style&index=0&id=378bc1eb&lang=scss"

const __exports__ = script;

export default __exports__